<!--
 * @Description: 
 * @Author: zhanghongquan
 * @Date: 2022-04-02 14:28:12
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-12-29 20:23:25
-->
<template>
  <div class="content">
    <div class="initial-btn" @click="initialAddress">
      <i class="iconfont icon-chushidingwei"></i>
    </div>
    <div id="map"></div>
    <div class="speed_div">
      <div class="speed" v-show="popVisible">
        <li
          class="li"
          v-for="(item, index) in speedList"
          :key="index"
          :class="{ active: index == speedIsActive }"
          @click.stop="handlePlay('accelerate', index)"
        >
          {{ item.speedTimes }}
        </li>
      </div>
    </div>
    <div class="map_bottom" v-if="bottomFlag">
      <div class="bottom_content">
        <div class="li" @click.stop="speedChange('slowdown')">
          <img src="@/assets/icon_slowdown.png" alt="" />
          <p>减速</p>
        </div>
        <div class="li" @click="handlePlay(operationForPauseAndContinue)">
          <img :src="continueOrStopUrl" alt="" />
          <p id="pauseBtns">开始</p>
        </div>
        <div class="li" @click.stop="speedChange('accelerate')">
          <img src="@/assets/icon_accelerate.png" alt="" />
          <p>加速</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as maptalks from "maptalks";
import TalksMap from "@/utils/initMapTalksTrajectory.js";
export default {
  data() {
    return {
      iot: {},
      iot_day: {},
      bottomFlag: true,
      TalksMapDialog: new TalksMap(),
      dialogDetail: false,
      calendarFlag: true,
      operationForPauseAndContinue: "start",
      stopedIndex: 0,
      trackList: [],
      kaishi: require("@/assets/start.png"),
      continueOrStopUrl: require("@/assets/start.png"),
      tingzhi: require("@/assets/stop.png"),
      speedList: [
        {
          speedTimes: "0.5X",
          speed: 800,
        },
        {
          speedTimes: "1X",
          speed: 400,
        },
        {
          speedTimes: "2X",
          speed: 200,
        },
        {
          speedTimes: "3X",
          speed: 133,
        },
      ],
      speedIsActive: 1,
      popVisible: false,
      closeAll: true,
      coordinate: [116.421516, 39.911614],
    };
  },
  props: ["imei", "workStartTime", "workEndTime", "iotType"],
  watch: {},
  mounted() {
    this.initMap();
    this.getWorkTrajectory();
  },
  methods: {
    /**
     * @Description:
     * @Author: yangsibo
     * @Date: 2022-12-29 09:12:20
     * @return {*}
     */
    initialAddress() {
      this.TalksMapDialog.map.setCenter(this.coordinate);
    },
    // 关闭轨迹
    closeTrack() {
      this.$emit("closeTrajectory");
    },
    // 轨迹查看获取数据
    getWorkTrajectory() {
      let { imei, workStartTime, workEndTime, iotType } = this;
      let params = {
        imei,
        workStartTime,
        workEndTime,
        iotType,
      };
      this.$http.work
        .getWorkTrajectory(params)
        .then((res) => {
          let data = res.data,
            list = data.result;
          this.trackList = list;
          this.iot = data.iot;
          this.iot_day = data.iot_day;
          if (list.length == 0) {
            this.bottomFlag = false;
            // this.$message.error("暂无轨迹");
            return false;
          }
          if (this.lngLatCenter) {
            this.coordinate = this_.lngLatCenter;
            this.TalksMapDialog.map.setCenter(this_.lngLatCenter);
          } else {
            let Coordinate = {
              x: Number(list[0].lng),
              y: Number(list[0].lat),
            };
            this.coordinate = Coordinate;
            this.TalksMapDialog.map.setCenter(Coordinate);
          }
          this.TalksMapDialog.drawLine(list);
        })
        .catch(() => {
          console.log("获取轨迹查看出错了");
        });
    },
    handelReturn() {
      let flag = this.closeAll ? 1 : 6;
      this.$emit("childFn", flag);
      //清除小车跑定时器
      if (this.TalksMapDialog._timer || this.TalksMapDialog.i > 0) {
        clearInterval(this.TalksMapDialog._timer);
        this.TalksMapDialog._timer = "";
        this.TalksMapDialog.i = 0;
      }

      this.dialogDetail = false;
      this.trackList = [];

      this.TalksMapDialog.lastLineLayer.clear();
      this.TalksMapDialog.carPoint.clear();
      this.TalksMapDialog.fist = true;
      this.TalksMapDialog.lineLog = [];
      this.TalksMapDialog.lastLinePoints = [];

      this.operationForPauseAndContinue = "start";
      if (this.TalksMapDialog.btnName) {
        this.dialogGamps.btnName = "";
      }

      document.getElementById("pauseBtns").innerHTML = "开始";
      this.continueOrStopUrl = this.kaishi;
      this.calendarFlag = true;
    },
    initMap() {
      if (!this.TalksMapDialog.map) {
        this.TalksMapDialog.init("map", 16);
      }
    },
    speedChange(typeName) {
      if (this.popVisible) {
        if (typeName == "slowdown") {
          this.speedIsActive =
            this.speedIsActive == 0 ? 0 : this.speedIsActive - 1;
        } else {
          let len = this.speedList.length - 1;
          this.speedIsActive =
            this.speedIsActive == len ? len : this.speedIsActive + 1;
        }
        this.speedNum = this.speedList[this.speedIsActive].speed;
        if (this.trackList.length > 0) {
          this.TalksMapDialog.playBack(
            this.trackList,
            typeName,
            this.stopedIndex,
            this.stopedIndex > 0,
            undefined,
            this.speedNum
          );
        }
      } else {
        this.popVisible = true;
      }
    },
    handlePlay(typeName, index) {
      if (index || index === 0) {
        this.speedNum = this.speedList[index].speed;
      }
      if (typeName === "start") {
        //开始
        let name_ = this.$store.state.kName;
        this.$store.state.kName = name_ ? "" : "start";
        //					this.clearPolyline();
        this.stopedIndex = 0;
        this.calendarFlag = false;
        this.operationForPauseAndContinue = "pause";
        document.getElementById("pauseBtns").innerHTML = "停止";
        this.continueOrStopUrl = this.tingzhi;
        this.speedNum = 400;
        this.speedIsActive = 1;
      } else if (typeName === "pause") {
        //停止
        this.stopedIndex = this.TalksMapDialog.i;
        this.operationForPauseAndContinue = "continue";
        document.getElementById("pauseBtns").innerHTML = "继续";
        this.continueOrStopUrl = this.kaishi;
        this.calendarFlag = true;
        this.popVisible = false;
      } else if (typeName === "continue") {
        //继续
        this.operationForPauseAndContinue = "pause";
        document.getElementById("pauseBtns").innerHTML = "停止";
        this.continueOrStopUrl = this.tingzhi;
        this.calendarFlag = false;
      } else if (typeName === "stop") {
        this.TalksMapDialog.lastLinePoints = [];
        this.calendarFlag = true;
        this.popVisible = false;
      } else if (typeName === "accelerate") {
        //加速减速
        this.speedIsActive = index;
        this.speedNum = this.speedList[index].speed;
      }
      if (this.trackList.length > 0) {
        this.TalksMapDialog.playBack(
          this.trackList,
          typeName,
          this.stopedIndex,
          this.stopedIndex > 0,
          undefined,
          this.speedNum
        );
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  width: 100%;
  height: 700px;
  overflow: hidden;
  position: relative;
  .speed_div {
    width: 96%;
    position: absolute;
    left: 2%;
    bottom: calc(3% + 80px);
  }
  .speed {
    width: 20%;
    padding: 10px 20px 10px 20px;
    background: rgba($color: #000000, $alpha: 0.8);
    border-radius: 10px;
    display: flex;
    margin: 0 auto;
    .li {
      flex: 1;
      color: white;
      display: flex;
      justify-content: center;
      cursor: pointer;
    }
    .active {
      color: blue;
    }
  }
  .initial-btn {
    position: absolute;
    top: 15px;
    left: 15px;
    z-index: 1;
    cursor: pointer;
    width: 40px;
    height: 40px;
    background: #ffffff;
    border-radius: 5px;
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    .iconfont {
      color: #018388;
      font-size: 24px;
    }
  }
  #map {
    width: 100%;
    height: 100%;
  }
  .map_header {
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    padding: 10px 1% 20px 1%;
    .item {
      margin: 0 auto;
      .item_top {
        width: 100%;
        padding-bottom: 10px;
        border-bottom: 1px solid #585858;
        display: flex;
        justify-content: space-between;
        align-items: center;
        p {
          color: #00f6ff;
          font-size: 16px;
          font-weight: bold;
          margin-left: 5px;
          display: flex;
          align-items: center;
          &:before {
            content: "";
            display: inline-block;
            width: 5px;
            height: 20px;
            background: #00f6ff;
            border-radius: 3px;
            margin-right: 5px;
          }
        }
        .el-button {
          font-size: 14px;
        }
      }
      .item_bottom {
        width: 100%;
        height: 40%;
        display: flex;
        flex-wrap: wrap;
        .item_li {
          width: 15%;
          color: white;
          margin-top: 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 16px;
        }
        .item_lis {
          width: 25%;
        }
      }
    }
  }
  .map_bottom {
    height: 75px;
    padding: 0 1%;
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .bottom_content {
      width: 14%;
      height: 100%;
      display: flex;
      .li {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        img {
          width: 2vw;
        }
        p {
          color: white;
        }
      }
    }
  }
  ::v-deep .maptalks-attribution {
    opacity: 0;
  }
}
</style>
